import { render, staticRenderFns } from "./VideoUploadStep1.vue?vue&type=template&id=38effc2e&scoped=true&"
import script from "./VideoUploadStep1.vue?vue&type=script&lang=js&"
export * from "./VideoUploadStep1.vue?vue&type=script&lang=js&"
import style0 from "./VideoUploadStep1.vue?vue&type=style&index=0&id=38effc2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38effc2e",
  null
  
)

export default component.exports